import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import commonFormMeta from '@Shared/components/form/commonFormMeta';

export interface ICardsNumberByStatusReasonAndCardNetworkTypeMeta{
  bank: FormInputMeta;
  agency: FormInputMeta,
  startDate: FormInputMeta,
  endDate: FormInputMeta,
  cardNetworkType: FormInputMeta,
  cardStatus: FormInputMeta,
  cardType: FormInputMeta,
  cardStatusPattern: FormInputMeta,
  schema: any,
}

const CardsNumberByStatusReasonAndCardNetworkTypeMeta: ICardsNumberByStatusReasonAndCardNetworkTypeMeta = {} as ICardsNumberByStatusReasonAndCardNetworkTypeMeta;

CardsNumberByStatusReasonAndCardNetworkTypeMeta.bank = commonFormMeta.bank;
CardsNumberByStatusReasonAndCardNetworkTypeMeta.agency = commonFormMeta.agency;
CardsNumberByStatusReasonAndCardNetworkTypeMeta.cardStatus = commonFormMeta.cardStatus;
CardsNumberByStatusReasonAndCardNetworkTypeMeta.cardType = commonFormMeta.cardType;
CardsNumberByStatusReasonAndCardNetworkTypeMeta.startDate = commonFormMeta.startDate;
CardsNumberByStatusReasonAndCardNetworkTypeMeta.endDate = commonFormMeta.endDate;

CardsNumberByStatusReasonAndCardNetworkTypeMeta.cardNetworkType = {
  name: 'cardNetworkType',
  type: 'select',
  label: 'Type reseau carte',
  options:  [
    {
      label: 'Type reseau carte A',
      value: 'a'
    },
    {
      label: 'Type reseau carte B',
      value: 'b',
    },
    {
      label: 'Type reseau carte C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};
CardsNumberByStatusReasonAndCardNetworkTypeMeta.cardStatusPattern = {
  name: 'cardStatusPattern',
  type: 'select',
  label: 'Motif statut carte',
  options:  [
    {
      label: 'Motif statut carte A',
      value: 'a'
    },
    {
      label: 'Motif statut carte B',
      value: 'b',
    },
    {
      label: 'Motif statut carte C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};
CardsNumberByStatusReasonAndCardNetworkTypeMeta.startDate = commonFormMeta.startDate;
CardsNumberByStatusReasonAndCardNetworkTypeMeta.endDate = commonFormMeta.endDate;

CardsNumberByStatusReasonAndCardNetworkTypeMeta.schema = yup.object().shape(getValidationSchema(CardsNumberByStatusReasonAndCardNetworkTypeMeta));

export default CardsNumberByStatusReasonAndCardNetworkTypeMeta;

